import React, { useEffect } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { useAuth0, PolicyProvider } from 'utils';
import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';

import config from './../config';
import { Layout, NotFound, PublicLayout } from './layout';
import PaymentLayout from './payment';
import Initial from './payment/pages/Initial';
import Summary from './payment/pages/Summary';
import {
  AccountUnblocked,
  CreateAccount,
  EmailVerification,
  RestartLogin,
} from './layout/login';
import Landing from './layout/Landing';
import Dashboard from './dashboard';
import Help from './layout/faq/Help';
import UserProfile from './layout/userProfile';
import MaintenancePage from './layout/MaintenancePage';

datadogRum.init({
  applicationId: config.datadog.id,
  clientToken: config.datadog.secret,
  site: config.datadog.site,
  service: 'myslide',
  env: config.datadog.env,
  sessionSampleRate: 100,
  sessionReplaySampleRate: 100, // if not included, the default is 100
  trackResources: true,
  trackLongTasks: true,
  trackUserInteractions: true,
  trackFrustrations: true,
});

datadogLogs.init({
  clientToken: config.datadog.secret,
  site: config.datadog.site,
  service: 'myslide',
  env: config.datadog.env,
  forwardErrorsToLogs: true,
  sampleRate: 100,
});

const App = () => {
  const { isAuthenticated, user } = useAuth0();

  useEffect(() => {
    if (isAuthenticated && user?.sub) {
      datadogRum.setUser({
        id: user.sub,
      });

      return;
    }

    datadogRum.clearUser();
  }, [isAuthenticated, user?.sub]);

  return (
    <BrowserRouter>
      {config.maintenancePage === 'true' ? (
        <MaintenancePage />
      ) : (
        <Routes>
          <Route path="/payments" element={<PaymentLayout />}>
            <Route index element={<Initial />} />
            <Route path="summary" element={<Summary />} />
          </Route>

          <Route
            path="/"
            element={
              isAuthenticated && user ? (
                <PolicyProvider>
                  <Layout />
                </PolicyProvider>
              ) : (
                <PublicLayout />
              )
            }
          >
            <Route
              index
              element={isAuthenticated && user ? <Dashboard /> : <Landing />}
            />
            <Route
              path="/login"
              element={
                isAuthenticated && user ? <Dashboard /> : <RestartLogin />
              }
            />
            <Route path="create-account" element={<CreateAccount />} />
            <Route path="account-unblocked" element={<AccountUnblocked />} />
            <Route path="email-verification" element={<EmailVerification />} />
            <Route path="/help" element={<Help />} />
            <Route path="/user-profile" element={<UserProfile />} />
            <Route path="/page-not-found" element={<NotFound />} />
            <Route path="*" element={<Navigate to="/page-not-found" />} />
          </Route>
        </Routes>
      )}
    </BrowserRouter>
  );
};

export default App;
